import {
  AnalyticsError,
  AnalyticsEvent,
  EventType,
  LinkName,
  type Payload,
  type RoleRequirementsEvent,
  TrackingType,
  UnifiedAnalyticsEvent,
  UnifiedAnalyticsMessageCode,
  type UnifiedAlertPayload,
} from '../types';

import { spreadableTestingId } from './experiments';

interface PreferredAnswerNotSelectedPayload
  extends Payload<TrackingType.Link, LinkName.ErrorMessageShown> {
  eventName: [AnalyticsEvent.ErrorMessageShown];
  errorMessage: AnalyticsError.PreferredAnswerNotSelected;
}
interface UnifiedPreferredAnswerNotSelectedPayload
  extends UnifiedAlertPayload<UnifiedAnalyticsMessageCode.NoPreferredAnswers> {}

const sendPreferredAnswerNotSelectedEvent =
  (
    onEvent: (event: RoleRequirementsEvent) => void,
    unifiedAnalytics: boolean,
  ) =>
  (message: string): void => {
    const analyticsPayload = unifiedAnalytics
      ? ({
          eventName: UnifiedAnalyticsEvent.AlertViewed as const,
          currentPageSection: 'role requirements' as const,
          alertShown: {
            type: 'banner' as const,
            message,
            messageCode: UnifiedAnalyticsMessageCode.NoPreferredAnswers,
          },
          ...spreadableTestingId(),
        } as UnifiedPreferredAnswerNotSelectedPayload)
      : ({
          trackingType: TrackingType.Link,
          linkName: LinkName.ErrorMessageShown,
          eventName: [AnalyticsEvent.ErrorMessageShown],
          errorMessage: AnalyticsError.PreferredAnswerNotSelected,
          ...spreadableTestingId(),
        } as PreferredAnswerNotSelectedPayload);

    const spreadableName = unifiedAnalytics
      ? {}
      : {
          name: EventType.Error,
        };

    onEvent({
      data: [
        {
          payload: {
            analytics: analyticsPayload,
          },
          ...spreadableName,
        },
      ],
    });
  };

export {
  type PreferredAnswerNotSelectedPayload,
  type UnifiedPreferredAnswerNotSelectedPayload,
  sendPreferredAnswerNotSelectedEvent,
};
